module.exports = __webpack_public_path__ + "img/paragon-logo.34c34217.png";